import type { ReactNode } from 'react';

/**
 * A folded tile's icon while its chat streams: the icon itself pulses
 * gently instead of a ring spinning around it. Still for reduced motion;
 * the tile's label already says it is running.
 */
export function RunningPulse({ children }: { children: ReactNode }) {
  return (
    <span
      data-running-pulse
      className='grid animate-pulse place-items-center motion-reduce:animate-none'
    >
      {children}
    </span>
  );
}
